import { Box, FormControl, FormGroup, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { useMemo } from "react";
import { IncentivationSourceType } from "../../../../types/actionModule/incentivationSource/incentivationSourceModel";
import { incentivationSources } from "../../../../types/actionModule/actionModuleTypes";
import { IncentivationSourceState } from "../../../../types/actionModule/editor/actionModuleEditorTypes";
import { useTranslation } from "react-i18next";

interface Props {
    value: IncentivationSourceState;
    onChange: (value: IncentivationSourceState) => void;
}

export default function IncentivationSourceEditor(props: Props) {
    const { t } = useTranslation();

    const incentivationSourceDefinition = useMemo(() =>
        incentivationSources.find((i) => i.type === props.value.selectedIncentivationSourceType),
        [props.value.selectedIncentivationSourceType]
    );

    const onChangeIncentivationSource = (newType: IncentivationSourceType) => {
        const incentivationSource = incentivationSources.find(
            (i) => i.type === newType,
        );

        props.onChange({
            selectedIncentivationSourceType: newType,
            incentivationSource: {
                ...incentivationSource?.defaultValue ?? {},
                type: newType
            },
        });
    };

    return <Box sx={{p: 2}}>
        <Typography variant="subtitle2">{t("actionModuleEditor.tabIncentivationSource.common")}</Typography>
        <FormGroup sx={{ gap: 2, pb: 2, pt: 1 }}>
            <FormControl sx={{ minWidth: 250 }}>
                <InputLabel>{t("actionModuleEditor.tabIncentivationSource.incentivationSourceType")}</InputLabel>
                <Select
                    value={props.value.selectedIncentivationSourceType}
                    label={t("actionModuleEditor.tabIncentivationSource.incentivationSourceType")}
                    disabled
                    size="small"
                    onChange={(v) => onChangeIncentivationSource(v.target.value as IncentivationSourceType)}>
                    {
                        incentivationSources.map((s) =>
                            <MenuItem key={s.type} value={s.type}>{t(s.name)}</MenuItem>
                        )
                    }
                </Select>
            </FormControl>
        </FormGroup>
        {
            incentivationSourceDefinition && <>
                {incentivationSourceDefinition.editor({
                    value: props.value.incentivationSource,
                    onChanged: (value) => props.onChange({
                        ...props.value,
                        incentivationSource: value
                    })
                })}
            </>
        }
    </Box>
}
